import { render, staticRenderFns } from "./tablegrid.vue?vue&type=template&id=150ac408&scoped=true&"
import script from "./tablegrid.vue?vue&type=script&lang=js&"
export * from "./tablegrid.vue?vue&type=script&lang=js&"
import style0 from "./tablegrid.vue?vue&type=style&index=0&id=150ac408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ac408",
  null
  
)

export default component.exports